/* This example requires Tailwind CSS v2.0+ */

import { Disclosure } from '@headlessui/react'
import {MenuIcon, XIcon } from '@heroicons/react/outline'

const navigation = [
    { name: 'HOME', href: '#', current: true },
    { name: 'ABOUT ME', href: '#/about-me/', current: false },
    { name: 'CONTACTS', href: '#/contacts', current: false }
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function NewTopMenu() {
    return (
        <Disclosure as="nav" className="bg-gray-800">
            {({ open }) => (
                <>
                    <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
                        <div className="relative flex items-center justify-between h-16">
                            
                            <div className="absolute inset-y-0 left-0 flex items-center">
                                {/* Mobile menu button*/}
                                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <XIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                        </div>
                    </div>

                    <Disclosure.Panel className="sm:hidden">
                        <div className="px-2 pt-2 pb-3 space-y-1">
                            {navigation.map((item) => (
                                <Disclosure.Button
                                    key={item.name}
                                    as="a"
                                    href={item.href}
                                    className={classNames(
                                        item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                        'block px-3 py-2 rounded-md text-base font-medium'
                                    )}
                                    aria-current={item.current ? 'page' : undefined}
                                >
                                    {item.name}
                                </Disclosure.Button>
                            ))}
                        </div>
                        <div></div>
                        <div></div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    )
}
